import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";

import * as colors from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { FOOTER_CLASSES } from "./constants";

export const FooterRootContainer = styled(Box)(({ theme }) => {
  return {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.up("sm")]: {
      paddingTop: theme.spacing(4),
    },
    [theme.breakpoints.up("md")]: {
      paddingTop: theme.spacing(6),
    },
    [theme.breakpoints.up("lg")]: {
      paddingTop: theme.spacing(8),
    },
    background: colors.COLOR_PRIMARY_WHITE,
    [`& ${FOOTER_CLASSES.container}`]: {
      display: "flex",
      justifyContent: "center",
    },
    [`& ${FOOTER_CLASSES.contentWrapper}`]: {
      maxWidth: 1312,
    },
    [`& ${FOOTER_CLASSES.evergageData}`]: {
      visibility: "hidden",
    },
  };
});

export const CountrySelectorWrapper = styled(Grid)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);
  return {
    [formatMedia.BREAKPOINT_LARGE_DESKTOP]: {
      display: "none",
    },
  };
});
